function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */
export default function isDOMElement(obj) {
  if (_typeof(obj) !== 'object' || obj === null) return false;
  if (!('nodeType' in obj)) return false;
  return obj.nodeType === Node.ELEMENT_NODE;
}